export function CloseLogoIcon() {
    return (
        <svg
            id="uuid-8cef59c9-be4f-4f68-a36d-4d04a7ad55d6"
            data-name="Livello 2"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 147.25 147.08"
            height={34}
            width={34}
        >
            <defs>
                <style>
                    {
                        "\n      .uuid-33559908-4f9f-4126-8682-b5b956173f89 {\n        fill: #008ccd;\n      }\n    "
                    }
                </style>
            </defs>
            <g
                id="uuid-95bc5022-de30-4aae-92e3-55cd948de7ff"
                data-name="uuid-86c305d7-94df-4880-bc67-7c60a1292330"
            >
                <path
                    className="uuid-33559908-4f9f-4126-8682-b5b956173f89"
                    d="M125.89,21.72C87.59-18.18,17.39-.38,2.59,52.92c-2.8,10-4.9,19.2,2.4,27.7,15.3,17.8,48.4,25.7,71,23.3,2.2-.2,4.4-.9,6.5-1.2.3,0,1.1-.3,1,.2-9.4,3.2-18.9,6.4-28.7,7.9-14.1,2.2-32.7-1.2-45.3-8-1.4-.8-2.6-2.3-4.4-2.2,0,.9.2,1.7.5,2.6,8.5,23.5,33.5,40.1,57.7,43.2,70.3,8.9,111.5-74,62.7-124.8h0v.1s-.1,0-.1,0ZM122.19,86.92l-4.9,22.2c-.5,1.3-2,1.8-3,2.6v-20.5l-16.8,6.7c-.9.8-.4,3.9-.4,5.3s0,4-1.8,4l-1.6-7.1c-1.2-.9-2.5.2-3.7.3l2.4-1.9c.3-.4,0-.8,0-1.2-.4-.8-5.1-5.2-4.9-5.5l1.6-.5c1.7.9,6.1,4.5,7.8,4.3l14.5-8.9v-1.2l-15.7-11.2c-.3-.6,2.5-1.6,3.1-1.5l20.4,9.1c3.4.4,9.8-4.8,13.1-4.5.6,0,1.8.7,1.7,1.4-.4,2.7-9.3,6.4-11.5,8.1,0,0-.3,0-.3,0Z"
                />
            </g>
        </svg>
    )
}